import { LoadingIndicator } from "@/Icons/loadingIndicator";
import { trpc } from "@/Utils/trpc";

import React, { useMemo } from "react";

import { HistoryTable } from "./HistoryTable";
import { getHistoryEntries } from "./functions";
import { WithId } from "./types";

export const PointHistory: React.FC<WithId> = ({ id }) => {
  const { data: history, isLoading } = trpc.history.getPointHistory.useQuery(
    { id },
    { gcTime: 0 },
  );
  const historyEntries = useMemo(() => getHistoryEntries(history), [history]);

  if (isLoading) {
    return (
      <div className="flex h-full min-h-full items-center justify-center">
        <LoadingIndicator />
      </div>
    );
  }

  return <HistoryTable entries={historyEntries} />;
};
